var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfoBoxNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.81 9.09h5.238v29.698H.952V1.212h31.43v6.06c0 1.005.639 1.82 1.428 1.82Zm-.477-7.878h.104l5.61 6.591v.076H33.81c-.264 0-.477-.272-.477-.606v-6.06ZM.953 40h38.095c.526 0 .952-.543.952-1.212V7.803c0-.338-.111-.66-.306-.89L34.084.32C33.906.115 33.68 0 33.44 0H.948C.422 0 0 .543 0 1.212v37.576C0 39.458.426 40 .952 40Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17.5c0-.276.244-.5.545-.5h22.91c.3 0 .545.224.545.5s-.244.5-.545.5H8.545c-.3 0-.545-.224-.545-.5Zm0 7c0-.276.244-.5.545-.5h22.91c.3 0 .545.224.545.5s-.244.5-.545.5H8.545c-.3 0-.545-.224-.545-.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBoxNote);
export default __webpack_public_path__ + "static/media/icon_info_box_note.063bc1a0bd31bb34a0fb50f65a571394.svg";
export { ForwardRef as ReactComponent };